import { Injectable } from '@angular/core';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

@Injectable({ providedIn: 'root' })
export class AircraftEventService {
  readonly FIRST_CUSTOM_EVENT_ID = 50000;

  constructor() {}

  isDefaultEventType(id: number, isOverride: boolean) {
    return (id < this.FIRST_CUSTOM_EVENT_ID && id !== 0) || isOverride;
  }

  isRefTypeAircraftHoldEvent(type: RefTypeItem): boolean {
    return this.isAircraftEventTypeIdHoldEvent(type.controlId);
  }

  isAircraftEventTypeIdHoldEvent(aircraftEventTypeControlId: number | undefined): boolean {
    return aircraftEventTypeControlId !== undefined && aircraftEventTypeControlId === 2;
  }
}
